import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { getHeaders } from '../utils/headers.functions';
import { Observable, tap } from 'rxjs';

const BASE_URL: string = environment.API_URL;

@Injectable({
  providedIn: 'root'
})
export class LandingsService {

  constructor(private http: HttpClient) { }


  getLandingPage(slug: any){
    return this.http.get<any>(`${BASE_URL}/landing/${slug}`);
  }

  public uploadImg(formData: any): Observable<any> {
    console.log('Enviando imagen al servidor...');
    const headers = getHeaders();  // Asegúrate de que este método retorne los headers necesarios
    return this.http.post<any>(`${BASE_URL}/uploadfile`, formData).pipe(
      tap(response => console.log('Respuesta recibida en uploadImg:', response))
    );
  }

  // Nuevo método para obtener imágenes en base64 desde el servidor
  public getImageAsBase64(type: string, filename: string): Observable<any> {
    const headers: HttpHeaders = getHeaders();
    return this.http.get<any>(`${BASE_URL}/file/${type}/${filename}`, { headers });
  }
  
  public uploadResource(formData: any): Observable<any> {
    const headers: HttpHeaders = getHeaders();
    return this.http.post<any>(`${BASE_URL}/uploadfile`, formData, { headers });
  }

  setProductInfo(body: any){
    const headers: HttpHeaders = getHeaders();
    return this.http.post<any>(`${BASE_URL}/info-product`, body, { headers });
  }

  updateProductInfo(body: any){
    const headers: HttpHeaders = getHeaders();
    return this.http.put<any>(`${BASE_URL}/info-product`, body, { headers });
  }

  // Nuevo método optimizado para actualización masiva
  bulkUpdateLandingPage(productId: number, properties: Array<{key: string, value: any}>){
    const headers: HttpHeaders = getHeaders();
    const body = { properties };
    return this.http.put<any>(`${BASE_URL}/landing-page/bulk/${productId}`, body, { headers });
  }

  // Guardar configuración del builder de Landing4
  saveLanding4Config(productId: number, config: any){
    const headers: HttpHeaders = getHeaders();
    return this.http.post<any>(`${BASE_URL}/landing-page/builder-config/${productId}`, { config }, { headers });
  }

  // Obtener configuración del builder de Landing4
  getLanding4Config(productId: number){
    const headers: HttpHeaders = getHeaders();
    return this.http.get<any>(`${BASE_URL}/landing-page/builder-config/${productId}`, { headers });
  }

  // Guardar landing page completa (payload final serializado)
  saveLandingPage(clienteId: number, payload: any){
    const headers: HttpHeaders = getHeaders();
    return this.http.post<any>(`${BASE_URL}/landing-pages/${clienteId}`, payload, { headers });
  }

  public getProduct(productId: string): Observable<any> {
    return this.http.get<any>(`${BASE_URL}/products/${productId}`);
  }

  public getProduct2(productId: string): Observable<any> {
    return this.http.get<any>(`${BASE_URL}/products2/${productId}`);
  }

  // ====== Builder de Landing (POST/PUT/GET por productId) ======
  // POST /landing-page/builder/:productId (upsert)
  saveLandingBuilder(productId: number, builderConfig: any): Observable<any> {
    const headers: HttpHeaders = getHeaders();
    return this.http.post<any>(`${BASE_URL}/landing-page/builder/${productId}`, builderConfig, { headers });
  }

  // PUT /landing-page/builder/:productId/hydrate (hidrata URLs->base64 y persiste)
  hydrateLandingBuilder(productId: number, builderConfig?: any): Observable<any> {
    const headers: HttpHeaders = getHeaders();
    const body = builderConfig ?? {};
    return this.http.put<any>(`${BASE_URL}/landing-page/builder/${productId}/hydrate`, body, { headers });
  }

  // GET /landing-page/builder/:productId (no hidratado)
  getLandingBuilder(productId: number): Observable<any> {
    const headers: HttpHeaders = getHeaders();
    return this.http.get<any>(`${BASE_URL}/landing-page/builder/${productId}`, { headers });
  }

  // ====== API de Landing Page 4 ======
  // POST /products/:productId/landing-page - Guardar/actualizar landing page
  saveLandingPage4(productId: number, payload: any): Observable<any> {
    const headers: HttpHeaders = getHeaders();
    return this.http.post<any>(`${BASE_URL}/products/${productId}/landing-page`, payload, { headers });
  }

  // GET /products/:productId/landing-page - Obtener landing page
  getLandingPage4(productId: number): Observable<any> {
    const headers: HttpHeaders = getHeaders();
    return this.http.get<any>(`${BASE_URL}/products/${productId}/landing-page`, { headers });
  }
}
